///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ExtendedStaticContent } from './extended-static-content.model';
import { StaticContentDTO } from '../../../generated/shared-types.model';
import { ReleaseNotesAboutSikluModel } from './release-note-items/release-notes-about-siklu.model';
import { ReleaseNotesTypes } from '../service/release-notes.types';

export class AboutSikluStaticContentModel implements ExtendedStaticContent {
    public readonly TITLE_TRANSLATION_PATH = 'global.menu.help.releaseNotes.aboutSiklu';
    public readonly TOOLTIP_TRANSLATION_PATH = 'releaseNotes.aboutSiklu';
    public id: number;
    public type: string;
    public content: ReleaseNotesAboutSikluModel;

    constructor(data: StaticContentDTO) {
        const { id, type, content } = data;
        this.id = id;
        this.type = type || ReleaseNotesTypes.ABOUT_SIKLU;
        this.content = this.createReleaseNotesAboutSikluModel(content);
    }

    getPlainObject(): StaticContentDTO {
        return {
            id: this.id,
            type: this.type,
            content: this.content.getPlainObject()
        };
    }

    getTitleTranslationPath() {
        return this.TITLE_TRANSLATION_PATH;
    }

    getTooltipTranslationPath() {
        return this.TOOLTIP_TRANSLATION_PATH;
    }

    update(item: any): ReleaseNotesAboutSikluModel {
        this.content = this.createReleaseNotesAboutSikluModel(item);
        return this.content;
    }

    private createReleaseNotesAboutSikluModel(content: any): ReleaseNotesAboutSikluModel {
        const { description = '', baseInfo = '', tel = '', fax = '', email = '' } = content ?? {};

        return new ReleaseNotesAboutSikluModel(description, baseInfo, tel, fax, email);
    }
}
